import { render } from "./fileLoading.vue?vue&type=template&id=590f4e95"
import script from "./fileLoading.vue?vue&type=script&lang=js"
export * from "./fileLoading.vue?vue&type=script&lang=js"

import "./fileLoading.vue?vue&type=style&index=0&id=590f4e95&lang=scss"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__